<template>
    <div id="app">
        <v-header v-if="!noHeader"></v-header>
        <div :class="content()" class="bg242">
            <keep-alive include="home,goods">
                <router-view />
            </keep-alive>

            <!--      <div class="service">-->
            <!--        本平台唯一客服：宝贝-->
            <!--        <p>QQ：25727558 </p>-->
            <!--        <p>微信：rxjh52077 （宝贝担保）</p>-->
            <!--        <p>QQ群：808627811 星霜（宝贝）交流群 </p>-->
            <!--      </div>-->
        </div>

        <!--    <v-footer v-if="!noFooter"></v-footer>-->
    </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    computed: {
      ...mapState([
        "noFooter",
        "noHeader"
      ])
    },
    methods: {
      content() {
        if (this.noFooter && this.noHeader) {
          return 'contentAll'
        } else if (this.noFooter && !this.noHeader) {
          return 'content'
        } else {
          return 'contentCenter'
        }
      },
    }
  }
</script>
<style lang="less">

    #app {
        display: flex;
        flex-direction: column;
        text-align: center;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*text-align: center;*/
        color: #2c3e50;
        font-size: 16px;
        .content {
            position: fixed;
            top: 49px;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 10;
            overflow: scroll;
        }

        .contentCenter {
            position: fixed;
            top: 0;
            bottom: 44px;
            left: 0;
            right: 0;
            z-index: 10;
            overflow: scroll;
        }

        .contentAll {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 10;
            overflow: scroll;
        }
    }
</style>
